import React, { useState, useEffect } from 'react';
import VisionModal from '../components/VisionModal';
import MissionModal from '../components/MissionModal';

const AboutUs = () => {
  const [language, setLanguage] = useState('english');
  const [isVisible, setIsVisible] = useState(false);
  const [showVisionModal, setShowVisionModal] = useState(false);
  const [showMissionModal, setShowMissionModal] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const toggleLanguage = () => {
    setLanguage(language === 'english' ? 'hindi' : 'english');
  };

  const handleJoinCommitteeClick = () => {
    alert("Committee membership will be available soon. Please check back later!\n\nसमिति की सदस्यता जल्द ही उपलब्ध होगी। कृपया बाद में देखें!");
  };

  const handleVisionLearnMore = () => {
    setShowVisionModal(true);
  };

  const handleMissionLearnMore = () => {
    setShowMissionModal(true);
  };

  return (
    <main className="w-full">
      {/* Enhanced Hero Section */}
      <section className="relative w-full h-[70vh] overflow-hidden">
        {/* Background Image Container with Parallax Effect */}
        <div 
          className="absolute inset-0 scale-110 transform transition-transform duration-1000 ease-out"
          style={{
            backgroundImage: "url('/images/About_img1.JPG')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            filter: 'brightness(0.7)'
          }}
        />

        {/* Enhanced Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/90 via-blue-800/80 to-slate-900/90 z-10" />

        {/* Animated Background Elements */}
        <div className="absolute inset-0 z-15">
          <div className="absolute top-20 left-20 w-32 h-32 bg-orange-500/20 rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-24 h-24 bg-blue-500/20 rounded-full animate-ping"></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-red-500/20 rounded-full animate-bounce"></div>
        </div>

        {/* Content Container with Enhanced Animations */}
        <div className="absolute inset-0 z-20">
          <div className="h-full flex items-center justify-center">
            <div className="text-center w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className={`space-y-6 md:space-y-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                {/* Enhanced Title with Better Typography */}
                <div className="space-y-4">
                  <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl 
                               font-black text-white 
                               leading-none tracking-tight
                               drop-shadow-2xl
                               animate-fade-in">
                    <span className="block transform hover:scale-105 transition-transform duration-300">About</span>
                    <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-red-500 to-orange-600
                                   animate-gradient-x">KNKSS</span>
                  </h1>
                  
                  {/* Subtitle */}
                  <p className="text-lg sm:text-xl md:text-2xl text-white/90 font-medium max-w-2xl mx-auto
                               animate-fade-in-delay">
                    {language === 'english' 
                      ? 'Empowering Youth Through Sports Excellence'
                      : 'खेल उत्कृष्टता के माध्यम से युवाओं को सशक्त बनाना'
                    }
                  </p>
                </div>
                
                {/* Enhanced Language Toggle Button */}
                <div className="mt-8 animate-fade-in-delay-2">
                  <button
                    onClick={toggleLanguage}
                    className="group relative bg-gradient-to-r from-orange-500 to-red-600 text-white
                             px-8 py-4 text-lg font-bold rounded-2xl
                             transition-all duration-500 ease-out
                             hover:from-orange-600 hover:to-red-700
                             hover:scale-105 hover:shadow-2xl
                             border-2 border-white/20
                             backdrop-blur-sm shadow-xl
                             overflow-hidden"
                  >
                    <span className="relative z-10 flex items-center space-x-2">
                      <span>{language === 'english' ? 'हिंदी में पढ़ें' : 'Read in English'}</span>
                      <svg className="w-5 h-5 transform group-hover:rotate-180 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-red-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

              {/* Main Content with Enhanced Styling */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Enhanced Organization Introduction */}
        <section className="w-full py-10 sm:py-14">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-orange-500 to-red-600 rounded-full text-white mb-6 shadow-xl">
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              {language === 'english' 
                ? 'Kabir Nagar Khel Samiti Society (KNKSS), Raipur' 
                : 'कबीर नगर खेल समिति (KNKS), रायपुर'
              }
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-orange-500 to-red-600 mx-auto mb-8 rounded-full"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {language === 'english'
                ? 'Transforming lives through the power of sports and community development'
                : 'खेल और सामुदायिक विकास की शक्ति के माध्यम से जीवन को बदलना'
              }
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-5">
            <div className="space-y-8">
              <div className="space-y-6">
                <p className="text-xl text-gray-700 font-medium text-left">
                  {language === 'english' 
                    ? 'Kabir Nagar Khel Samiti Society (KNKSS), Raipur, stands as a beacon of sports excellence and community development in Chhattisgarh. Established with a vision to transform lives through sports, we are dedicated to promoting the overall well-being and holistic development of young individuals through active participation in sports and physical activities.'
                    : 'कबीर नगर खेल समिति (KNKS), रायपुर, छत्तीसगढ़ में खेल उत्कृष्टता और सामुदायिक विकास की एक मशाल के रूप में खड़ी है। खेल के माध्यम से जीवन को बदलने की दृष्टि के साथ स्थापित, हम युवाओं की संपूर्ण भलाई एवं मानसिक और शारीरिक संतुलन हेतु खेलों और शारीरिक गतिविधियों में सक्रिय भागीदारी के माध्यम से उनके समग्र विकास को बढ़ावा देने के लिए प्रतिबद्ध हैं।'
                  }
                </p>
                <p className="text-xl text-gray-700 font-medium text-left">
                  {language === 'english'
                    ? 'Our organization serves as a cornerstone for sports development in the community, fostering growth, unity, and excellence in athletics while building character, leadership, and life skills that extend far beyond the playing field.'
                    : 'हमारा संगठन समुदाय में खेल विकास की आधारशिला का काम करता है, खेल में वृद्धि, एकता और उत्कृष्टता को बढ़ावा देते हुए चरित्र, नेतृत्व और जीवन कौशल का निर्माण करता है जो खेल के मैदान से कहीं आगे तक फैला है।'
                  }
                </p>
              </div>
              
              {/* Enhanced Stats */}
              <div className="grid grid-cols-3 gap-6 pt-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-orange-600 mb-2">15+</div>
                  <div className="text-sm text-gray-600 font-medium">
                    {language === 'english' ? 'Active Members' : 'सक्रिय सदस्य'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-2">25+</div>
                  <div className="text-sm text-gray-600 font-medium">
                    {language === 'english' ? 'Events Yearly' : 'वार्षिक कार्यक्रम'}
                  </div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600 mb-2">8+</div>
                  <div className="text-sm text-gray-600 font-medium">
                    {language === 'english' ? 'Years Experience' : 'वर्षों का अनुभव'}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative group">
              <div className="aspect-w-4 aspect-h-3 rounded-3xl overflow-hidden shadow-2xl transform group-hover:scale-105 transition-transform duration-700">
                <img 
                  src="/images/image_1.JPG" 
                  alt="KNKSS Sports Activities"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    const placeholder = document.createElement('div');
                    placeholder.className = 'w-full h-full bg-gradient-to-br from-teal-100 to-cyan-100 flex items-center justify-center';
                    placeholder.innerHTML = `
                      <div class="text-center">
                        <svg class="w-12 h-12 mx-auto mb-2 text-teal-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd" />
                        </svg>
                        <p class="text-teal-600 font-medium text-sm">About Image</p>
                        <p class="text-teal-500 text-xs">Unavailable</p>
                      </div>
                    `;
                    e.target.parentNode.appendChild(placeholder);
                  }}
                />
              </div>
              {/* Enhanced Decorative elements */}
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-gradient-to-r from-orange-500 to-red-600 rounded-full opacity-20 animate-pulse"></div>
              <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full opacity-20 animate-ping"></div>
              <div className="absolute top-1/2 -left-8 w-16 h-16 bg-green-500/20 rounded-full animate-bounce"></div>
            </div>
          </div>
        </section>

        {/* Enhanced Mission and Vision */}
        <section className="w-full py-20 sm:py-24 bg-gradient-to-br from-gray-50 via-white to-gray-100 rounded-3xl mb-5">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full text-white mb-6 shadow-xl">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
                {language === 'english' ? 'Our Purpose' : 'हमारा उद्देश्य'}
              </h2>
              <div className="w-32 h-1 bg-gradient-to-r from-orange-500 to-red-600 mx-auto mb-8 rounded-full"></div>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                {language === 'english'
                  ? 'Driving excellence and community development through sports'
                  : 'खेल के माध्यम से उत्कृष्टता और सामुदायिक विकास को आगे बढ़ाना'
                }
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="group bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100 transform hover:-translate-y-2">
                <div className="text-orange-600 mb-8 group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {language === 'english' ? 'Our Mission' : 'हमारा मिशन'}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed mb-6 text-left tracking-normal">
                  {language === 'english'
                    ? 'To promote cricket and provide a comprehensive platform for talented players to showcase their skills while fostering sportsmanship, community spirit, and the overall development of youth through innovative sports programs and physical activities.'
                    : 'युवाओं के समग्र विकास और खेल तथा शारीरिक गतिविधियों के माध्यम से समुदायिक भावना को बढ़ावा देना, साथ ही प्रतिभाशाली खिलाड़ियों को अपने कौशल प्रदर्शित करने का व्यापक मंच प्रदान करना।'
                  }
                </p>
                <button 
                  onClick={handleMissionLearnMore}
                  className="flex items-center text-orange-600 font-semibold hover:text-orange-700 transition-colors duration-200 cursor-pointer"
                >
                  <span>{language === 'english' ? 'Learn More' : 'और जानें'}</span>
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
              </div>

              <div className="group bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 border border-gray-100 transform hover:-translate-y-2">
                <div className="text-blue-600 mb-8 group-hover:scale-110 transition-transform duration-300">
                  <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {language === 'english' ? 'Our Vision' : 'हमारा विजन'}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed mb-6 text-left tracking-normal">
                  {language === 'english'
                    ? 'To become a leading sports organization that nurtures talent, promotes excellence, and contributes to the holistic development of youth and the strengthening of our community through sports.'
                    : 'एक अग्रणी खेल संगठन बनना जो प्रतिभा का पोषण करे, उत्कृष्टता को बढ़ावा दे, और खेलों के माध्यम से युवाओं के समग्र विकास और समुदाय के सुदृढ़ीकरण में योगदान दे।'
                  }
                </p>
                <button 
                  onClick={handleVisionLearnMore}
                  className="flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors duration-200 cursor-pointer"
                >
                  <span>{language === 'english' ? 'Learn More' : 'और जानें'}</span>
                  <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Expanded Aims and Objectives */}
        <section className="w-full py-8 sm:py-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              {language === 'english' ? 'Detailed Aims & Objectives' : 'विस्तृत लक्ष्य एवं उद्देश्य'}
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-red-600 mx-auto mb-8"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {language === 'english'
                ? 'Our comprehensive framework for youth development and community engagement through sports'
                : 'खेल के माध्यम से युवा विकास और सामुदायिक सशक्तिकरण के लिए हमारा व्यापक ढांचा'
              }
            </p>
        </div>

          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="p-8 sm:p-12">              
              {language === 'english' ? (
                <div className="space-y-8">
                  <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                    The primary aims and objectives of Kabir Nagar Khel Samiti Society (KNKSS), Raipur, represent our commitment to comprehensive youth development and community empowerment:
                  </p>
                  
                  <div className="space-y-8">
                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                    1
                  </div>
                </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Encourage Physical Fitness and Mental Well-being</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To foster a healthy lifestyle by engaging youth in regular physical activities that contribute to both physical fitness and mental stability, promoting overall wellness and stress management through structured sports programs.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Regular fitness assessments and health monitoring</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Mental health awareness programs through sports psychology</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Yoga and meditation sessions for holistic wellness</li>
                        </ul>
                </div>
              </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-green-500 to-green-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                    2
                  </div>
                </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Promote Sports Culture Among Youth</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To organize and facilitate various sports events, including cricket tournaments and other competitive games, to identify, nurture, and showcase young sporting talent while building a strong sports ecosystem in our community.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Annual cricket tournaments and inter-school competitions</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Skills development workshops and training camps</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Sports scholarship programs for underprivileged youth</li>
                        </ul>
                </div>
              </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-purple-500 to-purple-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          3
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Provide a Platform for Emerging Talent</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To offer comprehensive opportunities for children and youth to participate in organized sports, helping them build confidence, teamwork, leadership, and discipline while discovering and developing their unique sporting abilities.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Talent identification and development programs</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Advanced coaching for promising athletes</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Pathways to state and national level competitions</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-red-500 to-red-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          4
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Strengthen Community Engagement Through Sports</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To bring communities together by promoting a spirit of unity, sportsmanship, and healthy competition through local and regional sports events, fostering social cohesion and community pride.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Community festivals and sports celebrations</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Inter-community tournaments and friendly matches</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Volunteer programs for community members</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-indigo-500 to-indigo-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          5
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Support the Development of Sports Infrastructure</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To advocate for and assist in the development of local sports facilities and training programs for sustained sports growth, ensuring accessibility and quality resources for all community members.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Modern training facilities and equipment upgrades</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Collaboration with government and private sectors</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Sustainable development practices in sports infrastructure</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-teal-500 to-teal-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          6
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Foster Education and Life Skills Development</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To integrate educational programs with sports activities, helping young athletes balance academics with athletics while developing essential life skills such as time management, goal setting, and resilience.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Academic support programs for student-athletes</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Life skills workshops and mentorship programs</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Career guidance and professional development opportunities</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          7
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Promote Inclusivity and Gender Equality</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To ensure equal opportunities for all participants regardless of gender, background, or economic status, creating an inclusive environment where everyone can pursue their sporting dreams and contribute to the community.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Women's cricket teams and leadership programs</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Special programs for differently-abled individuals</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Financial assistance and equipment support for underprivileged</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-pink-500 to-rose-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          8
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">To Build Environmental Awareness Through Sports</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">To promote environmental consciousness and sustainability through eco-friendly sports practices, encouraging participants to become responsible stewards of the environment while enjoying sports activities.</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Green sports initiatives and eco-friendly tournaments</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Environmental cleanup drives and tree plantation programs</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>Sustainable equipment and waste management practices</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-8">
                  <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                    कबीर नगर खेल समिति (KNKS), रायपुर के मुख्य लक्ष्य और उद्देश्य व्यापक युवा विकास और सामुदायिक सशक्तिकरण के प्रति हमारी प्रतिबद्धता को दर्शाते हैं:
                  </p>
                  
                  <div className="space-y-8">
                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          1
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">शारीरिक फिटनेस और मानसिक संतुलन को प्रोत्साहन देना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">युवाओं को नियमित शारीरिक गतिविधियों में संलग्न कर स्वस्थ जीवनशैली को बढ़ावा देना, जिससे शारीरिक और मानसिक दोनों दृष्टियों से उन्हें लाभ हो, संरचित खेल कार्यक्रमों के माध्यम से समग्र कल्याण और तनाव प्रबंधन को बढ़ावा देना।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>नियमित फिटनेस मूल्यांकन और स्वास्थ्य निगरानी</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>खेल मनोविज्ञान के माध्यम से मानसिक स्वास्थ्य जागरूकता कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>समग्र कल्याण के लिए योग और ध्यान सत्र</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-green-500 to-green-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          2
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">युवाओं में खेल संस्कृति का विकास करना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">क्रिकेट टूर्नामेंट सहित विभिन्न खेल प्रतियोगिताओं का आयोजन कर युवाओं में खेलों के प्रति रुचि बढ़ाना और उन्हें खेल प्रतिभा के प्रदर्शन का मंच प्रदान करना, साथ ही हमारे समुदाय में एक मजबूत खेल पारिस्थितिकी तंत्र का निर्माण करना।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>वार्षिक क्रिकेट टूर्नामेंट और अंतर-विद्यालय प्रतियोगिताएं</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>कौशल विकास कार्यशालाएं और प्रशिक्षण शिविर</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>वंचित युवाओं के लिए खेल छात्रवृत्ति कार्यक्रम</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-purple-500 to-purple-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          3
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">उभरती प्रतिभाओं को मंच प्रदान करना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">बच्चों और युवाओं को संगठित खेल गतिविधियों में भाग लेने का व्यापक अवसर प्रदान करना, जिससे उनमें आत्मविश्वास, टीमवर्क, नेतृत्व और अनुशासन का विकास हो, साथ ही उनकी अनूठी खेल क्षमताओं की खोज और विकास हो।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>प्रतिभा पहचान और विकास कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>प्रतिभाशाली एथलीटों के लिए उन्नत कोचिंग</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>राज्य और राष्ट्रीय स्तर की प्रतियोगिताओं के लिए मार्ग</li>
                        </ul>
                </div>
              </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-red-500 to-red-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          4
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">खेलों के माध्यम से सामुदायिक सहभागिता को मजबूत करना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">स्थानीय और क्षेत्रीय खेल आयोजनों के माध्यम से एकता, खेल भावना और स्वस्थ प्रतिस्पर्धा को बढ़ावा देकर समुदायों को एक साथ लाना, सामाजिक सामंजस्य और सामुदायिक गर्व को बढ़ावा देना।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>सामुदायिक त्योहार और खेल समारोह</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>अंतर-सामुदायिक टूर्नामेंट और मैत्रीपूर्ण मैच</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>समुदायिक सदस्यों के लिए स्वयंसेवक कार्यक्रम</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-indigo-500 to-indigo-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          5
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">खेल अवसंरचना के विकास का समर्थन करना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">निरंतर खेल विकास के लिए स्थानीय खेल सुविधाओं और प्रशिक्षण कार्यक्रमों के विकास में सहायता और वकालत करना, सभी समुदायिक सदस्यों के लिए पहुंच और गुणवत्तापूर्ण संसाधन सुनिश्चित करना।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>आधुनिक प्रशिक्षण सुविधाएं और उपकरण उन्नयन</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>सरकारी और निजी क्षेत्रों के साथ सहयोग</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>खेल अवसंरचना में टिकाऊ विकास प्रथाएं</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-teal-500 to-teal-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          6
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">शिक्षा और जीवन कौशल विकास को बढ़ावा देना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">शैक्षणिक कार्यक्रमों को खेल गतिविधियों के साथ एकीकृत करना, युवा एथलीटों को शिक्षा और खेल के बीच संतुलन बनाने में मदद करना, साथ ही समय प्रबंधन, लक्ष्य निर्धारण और लचीलेपन जैसे आवश्यक जीवन कौशल विकसित करना।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>छात्र-एथलीटों के लिए शैक्षणिक सहायता कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>जीवन कौशल कार्यशालाएं और मार्गदर्शन कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>करियर मार्गदर्शन और व्यावसायिक विकास अवसर</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          7
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">समावेशिता और लिंग समानता को बढ़ावा देना</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">लिंग, पृष्ठभूमि या आर्थिक स्थिति की परवाह किए बिना सभी प्रतिभागियों के लिए समान अवसर सुनिश्चित करना, एक समावेशी वातावरण बनाना जहां हर कोई अपने खेल सपनों का पीछा कर सके और समुदाय में योगदान दे सके।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>महिला क्रिकेट टीमें और नेतृत्व कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>दिव्यांग व्यक्तियों के लिए विशेष कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>वंचितों के लिए वित्तीय सहायता और उपकरण सहायता</li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start group">
                      <div className="flex-shrink-0 mr-6">
                        <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gradient-to-r from-pink-500 to-rose-600 text-white font-bold text-lg shadow-lg group-hover:scale-110 transition-transform duration-300">
                          8
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 text-left">खेल के माध्यम से पर्यावरण जागरूकता निर्माण</h3>
                        <p className="text-gray-600 leading-relaxed text-lg mb-4 text-justify">पर्यावरण-अनुकूल खेल प्रथाओं के माध्यम से पर्यावरणीय चेतना और स्थिरता को बढ़ावा देना, प्रतिभागियों को खेल गतिविधियों का आनंद लेते हुए पर्यावरण के जिम्मेदार संरक्षक बनने के लिए प्रोत्साहित करना।</p>
                        <ul className="text-gray-600 space-y-2 ml-8">
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>हरित खेल पहल और पर्यावरण-अनुकूल टूर्नामेंट</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>पर्यावरण सफाई अभियान और वृक्षारोपण कार्यक्रम</li>
                          <li className="flex items-start pl-4"><span className="text-orange-500 mr-2">•</span>टिकाऊ उपकरण और अपशिष्ट प्रबंधन प्रथाएं</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Enhanced Contact Information */}
        <section className="w-full py-6 sm:py-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-500 to-green-600 rounded-full text-white mb-6 shadow-xl">
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              {language === 'english' ? 'Get In Touch' : 'संपर्क करें'}
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-orange-500 to-red-600 mx-auto mb-8 rounded-full"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {language === 'english'
                ? 'Ready to join our community? Reach out to us today!'
                : 'हमारे समुदाय में शामिल होने के लिए तैयार हैं? आज ही हमसे संपर्क करें!'
              }
            </p>
          </div>

          <div className="bg-gradient-to-br from-white via-gray-50 to-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="p-12 sm:p-16">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                <div className="group text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full text-white mb-6 shadow-xl group-hover:shadow-2xl transition-shadow duration-300">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {language === 'english' ? 'Phone' : 'फोन'}
                  </h3>
                  <p className="text-lg text-gray-600 font-medium">+91 76949 36100</p>
                  <p className="text-sm text-gray-500 mt-2">
                    {language === 'english' ? 'Call us anytime' : 'कभी भी कॉल करें'}
                  </p>
                </div>
                
                <div className="group text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-500 to-green-600 rounded-full text-white mb-6 shadow-xl group-hover:shadow-2xl transition-shadow duration-300">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {language === 'english' ? 'Email' : 'ईमेल'}
                  </h3>
                  <p className="text-lg text-gray-600 font-medium">knkskabirnagarraipur@gmail.com</p>
                  <p className="text-sm text-gray-500 mt-2">
                    {language === 'english' ? 'Send us a message' : 'हमें संदेश भेजें'}
                  </p>
                </div>
                
                <div className="group text-center transform hover:scale-105 transition-transform duration-300">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-orange-500 to-red-600 rounded-full text-white mb-6 shadow-xl group-hover:shadow-2xl transition-shadow duration-300">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {language === 'english' ? 'Location' : 'स्थान'}
                  </h3>
                  <p className="text-lg text-gray-600 font-medium">
                    {language === 'english' ? 'Kabir Nagar, Raipur, Chhattisgarh, India' : 'कबीर नगर, रायपुर, छत्तीसगढ़, भारत'}
                  </p>
                  <p className="text-sm text-gray-500 mt-2">
                    {language === 'english' ? 'Visit our facility' : 'हमारी सुविधा देखें'}
                  </p>
                </div>
              </div>

              {/* Enhanced CTA Button */}
              <div className="text-center mt-12">
                <button 
                  onClick={handleJoinCommitteeClick}
                  className="group bg-gradient-to-r from-orange-500 to-red-600 text-white
                           px-12 py-4 text-xl font-bold rounded-2xl
                           transition-all duration-500 ease-out
                           hover:from-orange-600 hover:to-red-700
                           hover:scale-105 hover:shadow-2xl
                           border-2 border-white/20
                           backdrop-blur-sm shadow-xl
                           overflow-hidden">
                  <span className="relative z-10 flex items-center justify-center space-x-3">
                    <span>{language === 'english' ? 'Join Our Community' : 'हमारे समुदाय में शामिल हों'}</span>
                    <svg className="w-6 h-6 transform group-hover:translate-x-2 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-orange-600 to-red-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Vision Modal */}
      <VisionModal 
        isOpen={showVisionModal} 
        onClose={() => setShowVisionModal(false)} 
        language={language} 
      />

      {/* Mission Modal */}
      <MissionModal 
        isOpen={showMissionModal} 
        onClose={() => setShowMissionModal(false)} 
        language={language} 
      />
    </main>
  );
};

export default AboutUs;

// Add custom CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fade-in-delay {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fade-in-delay-2 {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes gradient-x {
    0%, 100% {
      background-size: 200% 200%;
      background-position: left center;
    }
    50% {
      background-size: 200% 200%;
      background-position: right center;
    }
  }

  .animate-fade-in {
    animation: fade-in 1s ease-out;
  }

  .animate-fade-in-delay {
    animation: fade-in-delay 1s ease-out 0.3s both;
  }

  .animate-fade-in-delay-2 {
    animation: fade-in-delay-2 1s ease-out 0.6s both;
  }

  .animate-gradient-x {
    animation: gradient-x 3s ease infinite;
  }

  /* Smooth scrolling */
  html {
    scroll-behavior: smooth;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, #f97316, #dc2626);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(to bottom, #ea580c, #b91c1c);
  }
`;

// Add styles to document head if not already present
if (!document.querySelector('style[data-about-us-styles]')) {
  style.setAttribute('data-about-us-styles', 'true');
  document.head.appendChild(style);
} 